import { render, staticRenderFns } from "./CollapseWidth.vue?vue&type=template&id=cf6ba6a2&"
import script from "./CollapseWidth.vue?vue&type=script&lang=js&"
export * from "./CollapseWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports